import React from 'react'

import MetaTags from 'components/MetaTags'

import { CheckoutProvider, CheckoutConsumer } from 'contexts/Checkout'
import { SaasquatchProvider } from 'contexts/Saasquatch'
import { PromotionProvider } from 'contexts/Promotion'
import { NativeAuthProvider } from 'components/NativeAuth'
import { EngravingContextProvider } from 'components/buy/Engraving/EngravingContext'

const Providers = ({ children }) => {
  return (
    <>
      <MetaTags />
      <CheckoutProvider>
        <CheckoutConsumer>
          {({ checkout, setAuthSdk, setCheckoutUser }) => (
            <NativeAuthProvider checkout={checkout} setAuthSdk={setAuthSdk} setCheckoutUser={setCheckoutUser}>
              <SaasquatchProvider>
                <PromotionProvider>
                  <EngravingContextProvider>{children}</EngravingContextProvider>
                </PromotionProvider>
              </SaasquatchProvider>
            </NativeAuthProvider>
          )}
        </CheckoutConsumer>
      </CheckoutProvider>
    </>
  )
}

export default Providers
